<ng-container *ngIf="branch">
  <div>Location:</div>
  <div>{{ branch.name }}</div>
  <div>{{ branch.city }}, {{ branch.state }} {{ branch.zip }}</div>
  <div>{{ branch.phone }}</div>
</ng-container>
